import { Route } from 'react-router-dom';

import { TasteCalibrationPage } from './TasteCalibrationPage.js';

export function tasteCalibrationRoutes() {
  return (
    <Route
      path="/production-lines/:productionLineId/taste-calibration"
      element={<TasteCalibrationPage />}
    />
  );
}
